import { createSlice } from "@reduxjs/toolkit";
import { VehiclesType, VehiclesTypesState } from "./types";
import { applyExtraReducer } from "../../../weather";
import { createThunk } from "../../crops/selector";
import { FetchVehiclesBody } from "../commonTypes";
import { dashboardURL } from "@utils/utils";

const initialState: VehiclesTypesState = {
	data: [],
	isApiLoading: false,
	apiError: undefined
}

const fetchVehiclesTypes = createThunk<VehiclesType, FetchVehiclesBody, FetchVehiclesBody>()(
	{
		url: dashboardURL('vehicleStatusByType'),
		method: "POST"
	},
	(data, url) => ({ url, data })
)

const vehiclesTypesSlice = createSlice({
	initialState,
	name: 'vehiclesTypesSlice',
	reducers: {},
	extraReducers: builder => {
		applyExtraReducer(builder, fetchVehiclesTypes)
	}
})

export const actions = { ...vehiclesTypesSlice.actions, fetchVehiclesTypes }
export default vehiclesTypesSlice.reducer;